/**
 * A QR code as inline SVG. Vector, so it stays crisp whether it is 40 mm on
 * paper or filling a phone screen held up to a camera at the boat rail.
 */

import { useMemo } from "react";

import { encode, toSvg } from "../lib/qr";

interface QrCodeProps {
  payload: string;
  className?: string;
  title?: string;
}

export function QrCode({ payload, className, title }: QrCodeProps) {
  const svg = useMemo(() => (payload ? toSvg(encode(payload)) : ""), [payload]);

  return (
    <div
      className={className}
      role="img"
      aria-label={title ?? "GoPro Labs QR code"}
      // The SVG is generated from a string we built ourselves out of a payload
      // that has already been through the compiler's validation; there is no
      // path here for foreign markup to arrive.
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
